<template>
<div>
  <div class="columns">
    <div class="column">
      <h3 class="title is-3 has-text-info">{{ audit.standard.name }}</h3>
    </div>  
  </div>  
  <hr>

  <!-- <columns>
      <column>
        <div class="box is-fullheight has-text-centered">
          <p class="is-size-1">{{ checkpoints.length }}</p>
          <p>Checkpoints Assessed</p>
        </div>
      </column>
      <column>
        <div class="box is-fullheight has-text-centered">
          <p class="is-size-1">{{ findings.length }}</p>
          <p>Findings</p>
        </div>
      </column>
      <column>
        <div class="box is-fullheight has-text-centered">
          <p 
            class="is-size-1"
            :class="{
              'has-text-danger': audit.compliance_percentage < 85,
              'has-text-warning': audit.compliance_percentage > 85 && audit.compliance_percentage < 90,
            }">
            {{ audit.compliance_percentage }}%
          </p>
          <p>Compliance Level</p>
        </div>
      </column>
    </columns> -->
</div>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  computed: {
    ...mapGetters('audit', [
      'audit'
    ]),
    vulnerabilities() {
      return this.audit.findings.filter(finding => finding.vulnerability)
        .map(finding => finding.vulnerability)
    },
    lowVulnerabilities() {
      return this.vulnerabilities.filter(vulnerability => vulnerability.severity === 'LOW')
    },
    mediumVulnerabilities() {
      return this.vulnerabilities.filter(vulnerability => vulnerability.severity === 'MEDIUM')
    },
    highVulnerabilities() {
      return this.vulnerabilities.filter(vulnerability => vulnerability.severity === 'HIGH')
    },
  }

}
</script>